import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExpandPanel = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14.1211 9.17188C14.5115 8.78143 15.1446 8.78159 15.5352 9.17188L17.6572 11.293C18.0476 11.6834 18.0474 12.3165 17.6572 12.707L15.5352 14.8291C15.1446 15.2193 14.5115 15.2195 14.1211 14.8291C13.7307 14.4387 13.7309 13.8056 14.1211 13.415L14.5361 13H12C11.4477 13 11 12.5523 11 12C11.0002 11.4479 11.4479 11 12 11H14.5361L14.1211 10.5859C13.7308 10.1954 13.7308 9.56233 14.1211 9.17188Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M20 2C21.1046 2 22 2.89543 22 4V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V4C2 2.89543 2.89543 2 4 2H20ZM4 20H7V4H4V20ZM9 20H20V4H9V20Z",
		fill: "white"
	})]
});
export default SvgExpandPanel;
